import React from "react";
import { AutomateIcon, Button } from "@aidnas/design-system";

import { useChatContext } from "../context/ChatContext";

import styles from "../Styles.module.scss";

export function ChatToggleButton() {
  const { toggleChat } = useChatContext();

  return (
    <div className={styles.floating_button}>
      <Button
        aria-label="Open chat"
        density="spacious"
        iconEnd={<AutomateIcon />}
        onClick={toggleChat}
        variant="elevated"
      >
        Ask anything
      </Button>
    </div>
  );
}
